// Textos informativos para os tooltips dos campos de cálculo

export const tooltipTexts = {
    // Demandas
    demandaUnica: "Demanda contratada única para modalidade Verde (kW) - potência máxima demandada da rede elétrica.",
    demandaPonta: "Demanda contratada no horário de ponta (17h30-20h30) - período de maior carregamento e tarifas altas.",
    demandaForaPonta: "Demanda contratada fora do horário de ponta - período de menor carregamento e tarifas reduzidas.",
    demandaSemIcms: "Parcela da demanda não sujeita à incidência do ICMS conforme regulamentação estadual.",
    ultrapassagemDemanda: "Penalidade cobrada quando o consumo de demanda ultrapassa o valor contratado.",
    
    // Consumos
    tusdPonta: "TUSD ponta - Tarifa de Uso do Sistema de Distribuição + encargos setoriais.",
    tusdForaPonta: "TUSD fora ponta - Tarifa de Uso do Sistema de Distribuição + encargos setoriais.",
    tePonta: "Tarifa de Energia no horário de ponta - custo da energia elétrica propriamente dita.",
    teForaPonta: "Tarifa de Energia fora de ponta - custo da energia elétrica propriamente dita.",
    
    // Mercado Livre específico
    teAcl: "TE ACL - Tarifa de Energia do Ambiente de Contratação Livre adquirida de geradores/comercializadores.",
    perdasTransmissao: "Perdas técnicas no sistema de transmissão calculadas como percentual sobre o consumo.",
    energiaProinfa: "PROINFA - Programa de Incentivo às Fontes Alternativas. Pode ser custo (+) ou benefício (-).",
    
    // Tributos
    baseCalculoIcms: "Base de cálculo para incidência do ICMS (Imposto sobre Circulação de Mercadorias e Serviços) sobre a energia elétrica.",
    baseCalculoPisCofins: "Base de cálculo para incidência do PIS/COFINS sobre o consumo de energia elétrica.",
    icms: "Imposto sobre Circulação de Mercadorias e Serviços, tributo estadual incidente sobre o consumo de energia elétrica.",
    pisCofins: "Contribuições federais (PIS - Programa de Integração Social e COFINS - Contribuição para Financiamento da Seguridade Social).",
    
    // Outros valores
    liquidacaoFinanceira: "Resultado da liquidação no mercado de curto prazo, podendo ser positivo (custo) ou negativo (receita).",
    energiaReserva: "Encargo referente à Energia de Reserva, mecanismo para garantir a segurança do suprimento elétrico.",
    taxaCcee: "Taxa da Câmara de Comercialização de Energia Elétrica, órgão responsável pela operação do mercado livre.",
    taxaErcap: "Taxa da Empresa de Pesquisa Energética para estudos e planejamento do setor elétrico.",
    multaJurosCorrecao: "Valores referentes a multas, juros e correção monetária por atraso no pagamento.",
    descontos: "Descontos aplicados na fatura, como incentivos tarifários ou negociações comerciais.",
    outrosValores: "Outros valores diversos que podem compor a fatura de energia elétrica.",
    contaCovid: "Conta COVID-19, encargo temporário criado para compensar perdas do setor elétrico durante a pandemia.",
    
    // Bandeira tarifária
    bandeiraTarifaria: "Sistema de sinalização do custo real da energia elétrica. Cores indicam condições de geração: Verde (favorável), Amarela (menos favorável), Vermelha (desfavorável).",
    
    // Totais
    total: "Valor total da fatura antes da aplicação da bandeira tarifária.",
    totalComBandeira: "Valor final da fatura incluindo o adicional da bandeira tarifária."
};
